// @flow

import { authenticatedFetch } from '../../../api/request';

export default function getOrgs() {
    return authenticatedFetch('/v5/coaches/orgs');
}



// WEBPACK FOOTER //
// ./src/view/my-store/api/getOrgs.js